import { assert_number_gte_0, assert_string_not_empty, assert_type_enum } from '@shared/asserts/utils_asserts';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { DTO__database_entity } from '@shared/dto/_database_entity/DTO__database_entity';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { EMaintenanceStatus } from './e_maintenance_status';

export class DTO__app_info extends DTO__database_entity {
  /*
   * STATIC FIELDS
   */
  static _class_name_static: string = ENUM__dto_class_name.APP_INFO;

  /*
   * DB FIELDS
   */

  maintenance_status!: string;

  last_started_at!: number;
  last_started_at_string!: string;

  last_stopped_at!: number;
  last_stopped_at_string!: string;

  last_maintenance_started_at!: number;
  last_maintenance_started_at_string!: string; //optional

  last_start_duration!: number; //in ms
  last_shutdown_duration!: number; //in ms

  /*
   * METHODS
   */

  assert_standard_fields(): void {
    super.assert_standard_fields();

    assert_type_enum(this.maintenance_status, EMaintenanceStatus);

    assert_number_gte_0(this.last_started_at);
    assert_string_not_empty(this.last_started_at_string);

    assert_number_gte_0(this.last_start_duration);
  }

  is_maintenance_mode_enabled() {
    return CONSTANTS__shared.ACTIVE_MAINTENANCE_STATUSES.includes(this.maintenance_status);
  }
}
